module.exports = __webpack_public_path__ + "img/about-illustration@3x.1814ce18.png";